import bg1 from '../images/loaders/shapes/19.jpg';
import bg2 from '../images/loaders/shapes/24.jpg';
import bg3 from '../images/loaders/shapes/26.jpg';
import bg4 from '../images/loaders/shapes/44.jpg';
import bg5 from '../images/loaders/shapes/213.png';
import bg6 from '../images/loaders/shapes/220.jpg';
import me1 from '../images/pics/pic3.png';
import me2 from '../images/pics/pic2.jpg';
import me3 from '../images/pics/pic6.jpg';
import me4 from '../images/pics/pic1.jpg';
import me5 from '../images/pics/pic4.png';
import me6 from '../images/pics/pic6.jpg';



const images = {
    bg1,
    bg2,
    bg3, 
    bg4, 
    bg5,
    bg6,
    me1,
    me2,
    me3, 
    me4, 
    me5, 
    me6,
}
export default images;